import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { LogOut, Mail, Newspaper } from 'lucide-react';

export const Sidebar = () => {
  const auth = getAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="w-64 p-4 flex flex-col" style={{ background: 'var(--bg-secondary)', borderRight: '1px solid var(--border-subtle)' }}>
      <div className="flex items-center space-x-2 mb-8">
        <h1 className="h3" style={{ color: 'var(--text-primary)' }}>Admin</h1>
      </div>
      <nav className="flex-1">
        <ul>
          <li>
            <NavLink to="/admin/inquiries" className={({ isActive }) => `flex items-center space-x-2 p-2 rounded-lg transition-colors ${isActive ? 'bg-accent-primary text-white' : 'hover:bg-gray-700'}`}>
              <Mail className="w-5 h-5" />
              <span>Contact Inquiries</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/subscriptions" className={({ isActive }) => `flex items-center space-x-2 p-2 rounded-lg transition-colors ${isActive ? 'bg-accent-primary text-white' : 'hover:bg-gray-700'}`}>
              <Newspaper className="w-5 h-5" />
              <span>Newsletter Subscriptions</span>
            </NavLink>
          </li>
        </ul>
      </nav>
      <div>
        <button onClick={handleLogout} className="flex items-center space-x-2 p-2 rounded-lg transition-colors w-full hover:bg-gray-700">
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};